import React from "react";
//Material imports
import makeStyles from "@mui/styles/makeStyles";
import Grid from "@mui/material/Grid";
//Limitless imports
import Typography from "@limitless/modern/data-display/typography/Typography";
import { useExpertRatingContext } from "@limitless/expert";
import DropdownMenu from "@limitless/modern/inputs/dropdown-menu/DropdownMenu";

const useStyles = makeStyles({
    headerText: {
        display: "flex",
        flexDirection: "row",
        marginBottom: 4
    },
    text: {
        marginLeft: "3px"
    }
});

const RatingDashboardHeader = () => {
    const classes = useStyles();
    const { group, setGroup, groupSuggestions, setPage, clearRatingState } = useExpertRatingContext();

    const handleGroupChange = groupName => {
        clearRatingState();
        setGroup(groupName);
        setPage(1);
    };

    return (
        <Grid container direction="row" justifyContent="space-between" sx={{ padding: 0 }} spacing={0}>
            <Grid item md={10}>
                <Grid className={classes.headerText}>
                    <Typography color={theme => theme.palette.text.primary} variant="h6">
                        Your rating
                    </Typography>
                </Grid>
                <Typography color={theme => theme.palette.text.secondary} variant="body2">
                    {group.value === "all"
                        ? `Here you can see details of your rating across all groups. Use the dropdown on the right to see your
                        rating for a specific group.`
                        : `Here you can see details of your rating for group ${group.label}. Use the dropdown on the right to see your rating for a specific group.`}
                </Typography>
            </Grid>
            <Grid item md={2}>
                <DropdownMenu
                    placeholder="All groups"
                    id="userGroups"
                    skinny
                    options={groupSuggestions}
                    isOptionEqualToValue={(option, value) => option.value === value.value}
                    value={group}
                    onChange={(event, groupName) => handleGroupChange(groupName)}
                />
            </Grid>
        </Grid>
    );
};

export default RatingDashboardHeader;
